import React from 'react';

import Typography from '../../library/typography/typography';
import ProductDescription from '../product-description/product-description';

import { getProductFitmentPosition } from '../../shared/utils/product/product';

import { ProductData } from '../../shared/types/graphql-types';

import './product-set-description.scss';

interface ProductSetDescriptionProps {
  className?: string;
  product: ProductData;
}

function ProductSetDescription(props: ProductSetDescriptionProps) {
  const { className = '', product } = props;
  const { code, size } = product;
  const productFitmentPosition = getProductFitmentPosition(product);

  return (
    <div className={`product-set-description ${className}`}>
      <Typography
        className="product-set-description__label"
        styleName="label"
        tag="strong"
        weight="black"
      >
        {productFitmentPosition}
      </Typography>
      <ProductDescription code={code} size={size ? `${size}"` : undefined} />
    </div>
  );
}

export default ProductSetDescription;
